import image from "../../../../assets/images/docs/perftweak.png";
import * as React from 'react';
export default {
  image,
  React
};